$.fn.slickVideo = function (video_links) {
  new SlickVideo(this, video_links);
};

function SlickVideo (el, video_links) {
  var that = this,
    defaults = {
      mobile_width: 767,
      ratio: 16 / 9,
      custom_control: 0,
      player: {
        loop: 1,
        muted: 0,
        width: 640,
        height: 360,
        controls: 1
      }
    };
  that.options = $.extend({}, defaults);
  that.el = $(el);
  that.players = [];
  that.video_links = video_links;
  that.initialize();
}

SlickVideo.prototype = {

  initialize: function () {
    var that = this;
    that.initPlayers(0);
  },

  initSlider: function () {
    var that = this;
    that.el.on('init', function () {
      that.play(0);
    });
    that.el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      currentPlayer = that.getPlayer(currentSlide);
      nextPlayer = that.getPlayer(nextSlide);

      if (currentPlayer !== null) {
        if (currentSlide === nextSlide) {
          if (!currentPlayer.disableAutoplay) {
            currentPlayer.play();
          }
        } else {
          currentPlayer.pause();
        }
      }

      if (nextPlayer !== null) {
        if (currentSlide !== nextSlide) {
          if (!nextPlayer.disableAutoplay) {
            nextPlayer.play();
          }
        }
      }
    });
  },

  initPlayers: function (index) {
    var that = this,
      video_link = that.video_links[index];

    if (typeof video_link !== 'undefined') {
      var player = that.el.find('[src="' + video_link + '"]')[0],
        split_video = video_link.split('/'),
        video_id = split_video[split_video.length - 1].replace('.','');
      if (typeof player !== 'undefined') {
        player.disableAutoplay = false;
        var width = that.options.player.width,
          height = that.options.player.height,
          width_slider = that.el.width();
        if (that.options.mobile_width >= width && width > width_slider) {
          width = width_slider * 0.95;
          height = width / that.options.ratio;
          player.controls = that.options.player.controls;
        }
        player.width = width;
        player.height = height;
        player.loop = that.options.player.loop;
        player.muted = that.options.player.muted;
        player.controls = that.options.player.controls;
        that.players[video_id] = player;
        if(that.options.custom_control) {
          setTimeout(function () {
            that.initButton(video_id);
          }, 1500);
        }

        that.initPlayers(index + 1);
      }
    } else {
      that.initSlider();
    }
  },

  play: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.play();
    }
  },

  pause: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.pause();
    }
  },

  getPlayer: function (slideNumber) {
    var that = this,
      player = that.el.find('[data-slick-index="' + slideNumber + '"]').find('video')[0];
    return (player !== undefined) ? player : null;
  },

  initButton: function (video_id) {
    var that = this,
      player = that.players[video_id],
      player_container = $('#' + video_id),
      sliderWidth = that.el.width(),
      videoWidth = parseInt(player_container.attr('width')),
      marginLeft = (sliderWidth - videoWidth) / 2 + 5;

    player_container.after('<div id="video-btn-' + video_id + '" class="video-btn video-btn-pause" style="margin-left:' + marginLeft + 'px;"></div>');

    $('#video-btn-' + video_id).on('click', function (e) {
      var btn = e.currentTarget;
      e.stopPropagation();
      if (btn.className.indexOf('video-btn-pause') >= 0) {
        player.pause();
        player.disableAutoplay = true;
        btn.className = 'video-btn video-btn-play';
      } else {
        player.play();
        player.disableAutoplay = false;
        btn.className = 'video-btn video-btn-pause';
      }
    });
  }
};
